<div class="container-fluid">
  <div>
      <app-outward-supervisor-header (searchByName)="searchOfficeByName($event)" [tableSettings]="tableSetting.columns"></app-outward-supervisor-header>
  </div>
  <div class="mt-1">
<table class="table">
    <thead>
        <tr >
            <td class="w-8" *ngFor="let column of tableSetting.columns;let i = index">
                  <div *ngIf="column.isSortable">
                    
                      <span class="columheader" style="cursor:pointer">{{column.title}}</span>                   
                      <span class="icon-ic_filtered column-filter-icon cursor-pointer"  (click)="showSortingPopup(column)" *ngIf="column.isFilterIcon"></span>
                      
                  </div>
                  <div  *ngIf="!column.isSortable">
                      <span class="columheader">{{column.title}}</span>
                  </div>
                  <div class="resource-dropdown" *ngIf="column.displaysort">
                      <app-outward-supervisor-filter 
                      [registrationArray] = "registrationArray" 
                      [statusArray] = "statusArray"
                      [cityArray]="cityArray" 
                      [officeArray]="officeArray"
                      [column]="column" [tableSettings]="tableSetting" 
                      (gridFiltersApplied)="checkFilterApplied($event)"></app-outward-supervisor-filter>   
                  </div>
            </td>
        </tr>
    </thead>
    <tbody class="results-list-panel">          
              <div class="no-search-results"  *ngIf="((usersList!=null)&&(usersList.length==0))">
                  <img src="../../../../assets/images/No results.png" width="240px" height="200px"/>
                  <label style="color:black;line-height: 24px;font-weight: 600;">No registration to display</label>
                  <label>No registrations have been added to this<br/> list. To add new registration click the button<br/> below</label>
                  <br/>
                  <button routerLink="/AddOutward" routerLinkActive="active" class="button" type="button" style="border: 1px solid #007CB0;background-color: #fff;color: #007CB0;">New Registration</button>
              </div>
              <tr *ngFor="let consent of usersList | paginate: { itemsPerPage: 10, currentPage: p, totalItems: totalCount};let i = index" tooltip="Click to View Details">

          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" >{{consent.serialNumber ? consent.serialNumber  : '-'}}</span>
          </td>
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis1" tooltip="{{consent.gatepassNo}}">{{consent.gatepassNo ? consent.gatepassNo  : '-'}}</span>
          </td>
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
              <span class="showellipsis" style="width:107px;" tooltip="{{consent.requestName}}">{{consent.requestName ? consent.requestName  : '-'}}</span>
          </td>
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis" style="width:60px;" >{{consent.requestTypeName ? consent.requestTypeName  : '-'}}</span>
          </td>
         
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <div [ngClass]="{'bg-created':consent.status==='Created','bg-received':consent.status==='Received','bg-superApproved':consent.status==='Supervisor Approved','bg-appr1':consent.status==='LA approved 1','bg-appr2':consent.status==='LA Approved 2','bg-printPass':consent.status==='Print pass','bg-cancelled':consent.status==='Cancelled','bg-declined':consent.status==='Declined'}">
              <span class="showellipsis" >{{consent.status ? consent.status  : '-'}}</span></div>
            <!-- <span class="showellipsis"  [ngClass]="{'bg-created':consent.status==='Created','bg-received':consent.status==='Received','bg-superApproved':consent.status==='Supervisor approval','bg-appr1':consent.status==='LA approval 1','bg-appr2':consent.status==='LA approval 2','bg-printPass':consent.status==='Print pass','bg-cancelled':consent.status==='Cancelled'}" tooltip="View Details">{{consent.status ? consent.status  : '-'}}</span> -->
          </td>
         
          <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
            <span class="showellipsis1"  >{{consent.requestDateTime ? (consent.requestDateTime  | date:'d/MMM/y, h:mm a') : '-'}}</span>
          </td>
          <td class="text-truncate" (click)="detailedIOnfo(consent.requestId)">
            <!-- Non-Returnable items always show dash -->
            <span style="display: flex;justify-content: center;" class="showellipsis1" *ngIf="consent.requestTypeName == 'Non-Returnable'">-</span>
            
            <!-- Returnable items with Cancelled or Received status show dash -->
            <span style="display: flex;justify-content: center;" class="showellipsis1" *ngIf="consent.requestTypeName == 'Returnable' && (consent.status=='Cancelled' || consent.status=='Received')">-</span>
            
            <!-- Returnable items with other statuses show the return date -->
            <span class="showellipsis1" *ngIf="consent.requestTypeName == 'Returnable' && consent.status!='Cancelled' && consent.status!='Received' && !(duedatecomparer>consent.returnDateTime)" [ngStyle]="{'color': consent.duedatebeforetwodays ? '#FFBF00' : 'black'}">{{consent.returnDateTime | date:'d/MMM/y, h:mm a'}}</span>
            
            <!-- Returnable items that are overdue (not Cancelled/Received) show in red -->
            <span class="showellipsis1" *ngIf="consent.requestTypeName == 'Returnable' && consent.status!='Cancelled' && consent.status!='Received' && duedatecomparer>consent.returnDateTime" style="color: red;">{{consent.returnDateTime | date:'d/MMM/y, h:mm a'}}  
              <img src="../../../../assets/images/OIP.jpg" style="width:14px">
            </span>
          </td>

    <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
      <span class="showellipsis" [tooltip]=consent.cityName>{{consent.cityName ? consent.cityName  : '-'}}</span>
    </td>
    <td class="tablewidth" (click)="detailedIOnfo(consent.requestId)">
      <span class="showellipsis" [tooltip]=consent.officeName style="width:70px;">{{consent.officeName ? consent.officeName  : '-'}}</span>
    </td>
      
<td>
  <span *ngIf="consent.status==='Created' || consent.status==='LA approved 1' || consent.status==='LA Approved 2'" style="padding-top: 5px;float: right; 
          padding-right: 18px; cursor: pointer;" (click)="onAccept(consent.status,consent.requestId,consent.serialNumber)" tooltip="Approve">&#10004;</span>
</td>       
<td>
  <div *ngIf="consent.status==='Created' || consent.status==='LA approved 1' || consent.status==='LA Approved 2'" class="Deletebtn">
    <div class="BoxOne">
      <span style="padding-top: 5px;float: right; 
          padding-right: 18px; cursor: pointer;" (click)="onReject(consent)" tooltip="Reject">&#10006;</span>
    </div>
  </div>
  <span *ngIf="consent.status==='Supervisor Approved'" style="padding-top: 5px;float: right; 
          padding-right: 18px; cursor: pointer;" (click)="PrintPreview(consent,false)"  tooltip="Print Pass"><img src="../../../../assets/images/download.png" /></span>
  <li *ngIf="consent.status==='Print pass'" dropdown class="droplist dropdown-vendor"  routerLinkActive="active">
    <a id="basic-link" dropdownToggle 
    aria-controls="basic-link-dropdown" 
      aria-haspopup="true" aria-expanded="false">. . .
    </a> 
    <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu dropdown-menu-right menu-vendor"
      aria-labelledby="basic-link">
      <li *ngIf="consent.requestTypeName !='Non-Returnable'">
        <a class="dropdown-item vendor-item" (click)="onAccept(consent.status,consent.requestId,consent.serialNumber)">Mark as Received</a>
      </li>
      <li>
        <a (click)="PrintPreview(consent,true)" class="dropdown-item vendor-item">Print GatePass</a>
      </li>
      <li>
        <a class="dropdown-item vendor-item">Resend Email</a>
      </li>
    </ul>
  </li>
</td>
     <!-- <td *ngIf="consent.status==='Received'"></td>  -->
      </tr>
        </tbody>
    </table>
  </div>
  <div class="paginationwithcount" *ngIf="((usersList!=null)&&(usersList.length>0))" (click)="hideDropdowns()">
      <span class="mb-4 mx-4">Page</span>
      <pagination 
                  [(ngModel)]="filterData.page"
                  [boundaryLinks]="true" 
                  (pageChanged)="changeCurrentPage($event);p = $event"
                  [(totalItems)] = "totalCount"
                  [maxSize]="5"
                  firstText="&shy;"
                  lastText="&shy;"
                  previousText="&shy;"
                  nextText="&shy;"
                  [rotate]="false"
                  [itemsPerPage] = "itemsperPage"
                  >
      </pagination>  
  </div>
  <div class="totalcount" *ngIf="((usersList!=null)&&(usersList.length>0))"><span>{{((filterData.page -1) * itemsperPage )+ 1}} - {{ countLength }} of <b>{{totalCount}}</b></span></div>
</div>
